var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-structure-plan-edge-point",style:(`
    left: ${_vm.coordinates.x * _vm.model_zoom}px;
    top: ${_vm.coordinates.y * _vm.model_zoom}px;
    `)})
}
var staticRenderFns = []

export { render, staticRenderFns }